import { makeGetDictionariesKnmKindsSelectOptions } from 'CorePackage/DictionariesModule/selectors/dictionariesSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getErknmAnalyticsProsecutorOrganizationData = (state: IRootState) =>
  state.erknmAnalyticsProsecutorOrganization.data;
export const getErknmAnalyticsProsecutorOrganizationFilter = (state: IRootState) =>
  state.erknmAnalyticsProsecutorOrganization.filter;
export const getErknmAnalyticsProsecutorOrganizationTableColumns = (state: IRootState) =>
  state.erknmAnalyticsProsecutorOrganization.tableColumns;
export const getErknmAnalyticsProsecutorOrganizationDateTime = (state: IRootState) =>
  state.erknmAnalyticsProsecutorOrganization.localDateTime;
export const getErknmAnalyticsProsecutorOrganizationKnmOrder = (state: IRootState) =>
  state.erknmAnalyticsProsecutorOrganization.knmOrder;

export const getErknmAnalyticsProsecutorOrganizationKnmKindSelectOptions = (state: IRootState) => {
  const getDictionariesKnmKindsSelectOptions = makeGetDictionariesKnmKindsSelectOptions();

  return getDictionariesKnmKindsSelectOptions(state, undefined);
};
